import React from 'react';
import { useDialogStore } from 'hooks/dialogStore/useDialogStore';
import { LEGACY_DIALOG_KEYS } from 'modals/keys';
import LayoutContext from '../LayoutContext';
import { useConfiguredCounts } from '../../Router/onboarding/hooks';

export type OnboardingPreLaunchModalContextType = {
  visible: boolean;
  openModal: () => void;
  closeModal: () => void;
  configuredCount?: number;
  totalCount?: number;
};

const OnboardingPreLaunchModalContext =
  React.createContext<OnboardingPreLaunchModalContextType>(null);

export const OnboardingPreLaunchModalContextProvider: React.FC = ({
  children,
}) => {
  const { addDialog, removeDialog, isDialogVisible, isUsingNewArchitecture } =
    useDialogStore();
  const usingNewModalArch = isUsingNewArchitecture(
    LEGACY_DIALOG_KEYS.OnboardingPreLaunchModal,
  );

  const { setChatVisibility } = React.useContext(LayoutContext);
  const [visible, setVisible] = React.useState(false);

  const { totalCount, configuredCount } = useConfiguredCounts();

  const memoizedValue = React.useMemo(() => {
    const openModal: OnboardingPreLaunchModalContextType['openModal'] = () => {
      setChatVisibility(false);

      if (usingNewModalArch) {
        addDialog({ key: LEGACY_DIALOG_KEYS.OnboardingPreLaunchModal });
      } else {
        setVisible(true);
      }
    };

    const closeModal: OnboardingPreLaunchModalContextType['closeModal'] =
      () => {
        setChatVisibility(true);

        if (usingNewModalArch) {
          removeDialog(LEGACY_DIALOG_KEYS.OnboardingPreLaunchModal);
        } else {
          setVisible(false);
        }
      };

    return {
      visible: usingNewModalArch
        ? isDialogVisible(LEGACY_DIALOG_KEYS.OnboardingPreLaunchModal)
        : visible,
      openModal,
      closeModal,
      totalCount,
      configuredCount,
    };
  }, [
    addDialog,
    configuredCount,
    isDialogVisible,
    removeDialog,
    setChatVisibility,
    totalCount,
    usingNewModalArch,
    visible,
  ]);

  return (
    <OnboardingPreLaunchModalContext.Provider value={memoizedValue}>
      {children}
    </OnboardingPreLaunchModalContext.Provider>
  );
};

export default OnboardingPreLaunchModalContext;
